export function shouldUseGeometryStreamHints(
  useGeometryStreamHints: boolean,
  hintCount: number
): boolean {
  return useGeometryStreamHints && hintCount > 0;
}
